import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const banners = [{
  title: 'LIFT KITS',
  image: 'https://images.unsplash.com/photo-1580273916550-e323be2ae537?auto=format&fit=crop&w=700&q=80',
  link: '#'
}, {
  title: 'LEVELING KITS',
  image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0afa?auto=format&fit=crop&w=700&q=80',
  link: '#'
}, {
  title: 'SHOCKS & STRUTS',
  image: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=700&q=80',
  link: '#'
}];
export function CategoryBanners() {
  return <section className="w-full bg-white py-20" data-id="element-9">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8" data-id="element-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-11">
          {banners.map((banner, index) => <motion.a key={banner.title} href={banner.link} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative h-[350px] overflow-hidden block border-b-4 border-transparent hover:border-primary transition-all" data-id="element-12">
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" style={{
            backgroundImage: `url(${banner.image})`
          }} data-id="element-13" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/20 to-transparent transition-colors" data-id="element-14" />

              {/* Metallic sheen effect on hover */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-in-out" data-id="element-15"></div>

              <div className="absolute bottom-0 left-0 p-8 w-full" data-id="element-16">
                <h3 className="text-4xl font-heading font-bold text-white uppercase italic mb-2 tracking-tight drop-shadow-md" data-id="element-17">
                  {banner.title}
                </h3>
                <div className="flex items-center gap-2 text-primary font-heading font-bold uppercase italic tracking-wider text-lg group-hover:text-white transition-colors" data-id="element-18">
                  Shop Now <ArrowRight className="w-5 h-5" data-id="element-19" />
                </div>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}